import { render } from "./StagePanel.vue?vue&type=template&id=ade94176&scoped=true"
import script from "./StagePanel.vue?vue&type=script&lang=js"
export * from "./StagePanel.vue?vue&type=script&lang=js"

import "./StagePanel.vue?vue&type=style&index=0&id=ade94176&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade94176"]])

export default __exports__